import { createFileRoute, Outlet } from "@tanstack/react-router";
import { RequireAuth } from "@/components/RequireAuth";
import { PortalShell } from "@/components/portal/PortalShell";
import { useAuth } from "@/contexts/AuthContext";

export const Route = createFileRoute("/portal")({
  component: PortalLayout,
});

function PortalLayout() {
  const { session, isLoading } = useAuth();

  // Show a spinner while loading auth state (avoids blank flash on hard refresh)
  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-brand-blue-medium border-t-transparent" />
      </div>
    );
  }

  // RequireAuth will redirect if not authenticated. Session-timeout
  // enforcement (idle logout + quiet renewal) lives in PortalDataShell now,
  // not here — see its docblock.
  return (
    <RequireAuth>
      {session && <PortalShell session={session}><Outlet /></PortalShell>}
    </RequireAuth>
  );
}
